import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-invite",
  "use": "icon-invite-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-invite\"><path d=\"M810.667 853.333v64h-85.334v-64h-64V768h64v-64h85.334v64h64v85.333h-64zM490.667 576a234.667 234.667 0 1 1 234.24-234.667A234.496 234.496 0 0 1 490.667 576z m170.666 64l29.867 21.333h-8.533v64h-64V896h64v21.333H149.333V743.68L298.667 640h362.666z\" p-id=\"77566\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol